/**
 * El HTML base trae description/OG por defecto para quien no ejecuta JS (marcadas
 * `data-shell`, ver `build/siteShell.ts`). Con JS manda `SeoHead` (@unhead), que no sabe de
 * ellas: se quitan antes de montar React para que no queden duplicadas. El JSON-LD de
 * identidad no lleva `data-shell` y se queda (es igual para todas las páginas).
 */
export function removeShellHeadTags(doc: Document = document): void {
  doc.head.querySelectorAll('[data-shell]').forEach((el) => el.remove())
}
